import { convertLowerCamelToSnake } from '@/utils';

// NOTE:
// Since a Serializer is used in BE, no unnecessary parameters are passed.
// Also, PermittedProject is used, so access control is in effect.
// Basically, it is assumed to be used only on the BatchPage.

export const convertQueryParamsForPostRequest = (
  params: object,
  hasBracket?: boolean,
) => {
  const obj = convertLowerCamelToSnake(params);
  const searchParams = new URLSearchParams();

  for (const [key, value] of Object.entries(obj)) {
    if (typeof value === 'undefined' || value === null) {
      continue;
    }
    if (Array.isArray(value)) {
      for (const v of value) {
        searchParams.append(hasBracket ? `${key}[]` : key, String(v));
      }
    } else {
      searchParams.append(key, String(value));
    }
  }

  return searchParams.toString();
};
